import React from 'react';
import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import AuthForm from '@/components/authForm/AuthForm';
import { useEmotionDetectorContext } from '@/components/emotion-detector/EmotionDetectorContextProvider';
import EmotionDetectorFooter from '@/components/emotion-detector/EmotionDetectorFooter';
import messages from '@/components/emotion-detector/messages';
import { User } from '@/store/user/types';

import { PageContainer, StyledCard, Title } from './styles';

export default function SignupScreen() {
	const { formatMessage } = useIntl();
	const { setActiveScreen } = useEmotionDetectorContext();

	const handleAuthSuccess = (_user: User) => {
		// Navigate to home screen after successful auth
		setActiveScreen('home');
	};

	return (
		<>
			<PageContainer>
				<StyledCard>
					<Title>
						<Text el="h1">{formatMessage(messages.signupHeader)}</Text>
					</Title>
					<AuthForm onAuthSuccess={handleAuthSuccess} source="emotion-detector" />
				</StyledCard>
			</PageContainer>
			<EmotionDetectorFooter />
		</>
	);
}
